import React from "react"
import styled from "styled-components"
import Container from "./forLayout/container"

const Title = styled.h1`
  font-size: 5rem;
  font-family: "GFS Didot", serif;
  line-height: 4.8rem;
`

const Spacer = styled.div`
  padding: ${({ size }) => (size ? size : 2.5)}rem;
`

const Paragraph = styled.p`
  font-family: "GFS Didot", serif;
  font-size: 1.3rem;
  line-height: 3rem;
`

const FirstSection = () => {
  return (
    <Container>
      <Spacer />
      <Title>
        If they think your dreams are crazy, show them what crazy dreams can do.
      </Title>
      <Spacer />
      <Paragraph>
        Break a record history didn’t even know was possible.
        <br />
        Win a race that nobody invited you to compete in.
        <br />
        Live for a dream so crazy, it’ll do more than change sport…
      </Paragraph>
      <Spacer size={1} />
      <Paragraph>
        it’ll change the world.
        <br />
        For you. For her. For everyone.
      </Paragraph>
    </Container>
  )
}

export default FirstSection
